// @flow
import * as React from 'react';
import {
    ButtonContainer,
    CancelButton,
    NextButton,
    PaginationDot,
    PaginationDotActive,
    SequenceContainer,
    SequenceItem,
    SequenceList
} from './styles';
import { noop } from 'lodash/fp';

type Props = {
    cancel: string,
    index: number,
    next: string,
    onCancel: noop,
    onNext: noop,
    sequence: number
};

const SequenceCarousel = ({ cancel, index, next, onCancel, onNext, sequence }: Props) => (
    <SequenceContainer>
        <SequenceList>
            {[...Array(sequence)].map((x, i) => (
                <SequenceItem className={i === index && 'active'} key={i}>
                    {i + 1 === index ? <PaginationDotActive /> : <PaginationDot />}
                </SequenceItem>
            ))}
        </SequenceList>
        <ButtonContainer>
            <CancelButton alternate onClick={onCancel} type="button">
                {cancel}
            </CancelButton>
            <NextButton onClick={onNext} type="button">
                {next}
            </NextButton>
        </ButtonContainer>
    </SequenceContainer>
);

export default SequenceCarousel;



// WEBPACK FOOTER //
// ./src/components/widgets/sequence-carousel/index.js